import { render, staticRenderFns } from "./ContasWidget.vue?vue&type=template&id=3e32fdb8&"
import script from "./ContasWidget.vue?vue&type=script&lang=js&"
export * from "./ContasWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports